import type { ErrorBoundaryContextProps } from 'components/common-form/builder/form/errorBoundary';
import { isFailedToLoadDynamicImport } from 'components/common-form/builder/form/GenericErrorBoundary';
import { DynamicImportFailureFallback } from 'components/FatalError/DynamicImporFailureFallback';
import { FC } from 'react';
import type { FallbackProps } from 'react-error-boundary';
import styled from 'styled-components';

import { FatalError } from './FatalError';
import { TechnicalDetails } from './ResetButton';

export const StyledDiv = styled.div`
  width: 50vw;
`;

export const AppCrashedFallback: FC<FallbackProps & ErrorBoundaryContextProps> = ({ error, resetErrorBoundary }) => {
  if (isFailedToLoadDynamicImport(error)) {
    return <DynamicImportFailureFallback />;
  }
  return (
    <div className="bg-dark text-white vh-100">
      <FatalError titleKey="anErrorOccurred" detailsKey="errorTechnicalOops">
        <div className="d-flex m-5 justify-content-center">
          <StyledDiv>
            <TechnicalDetails
              className="flex-column"
              errorMessage={(error as Error)?.message}
              stack={(error as Error)?.stack}
              reset={resetErrorBoundary}
            />
          </StyledDiv>
        </div>
      </FatalError>
    </div>
  );
};
